import { ADD_ON_IDS } from '@ctct/domain-layer';

import type { Listeners, TEventSource } from '../helpers';
import { controllerHelpers } from '../helpers';
import {
  emailPlansEventBus,
  type AddOnsManager,
  type EmailPlanChangedPayload,
  type PayflowProgressBarManager,
  type RouterNonUiManager,
} from '../managers';

export class EmailPlansController {
  public listeners: Listeners;

  constructor(
    private routerManager?: RouterNonUiManager,
    private payflowProgressBarManager?: PayflowProgressBarManager,
    private addOnsManager?: AddOnsManager
  ) {
    this.listeners = controllerHelpers.createListeners([
      emailPlansEventBus.bindTo('emailPlanChanged', this.onEmailPlanChanged),
      emailPlansEventBus.bindTo('vision6PlanClicked', this.onVision6PlanClicked),
      emailPlansEventBus.bindTo('smsBundleRemoved', this.onSmsBundleRemoved),
    ]);
  }

  private onEmailPlanChanged = async (_payload: EmailPlanChangedPayload, { source }: { source: TEventSource }) => {
    if (source !== 'user') return;

    this.payflowProgressBarManager?.getApiWhenReady().then((api) => api.goToNextStep());
  };

  private onVision6PlanClicked = () => {
    this.routerManager?.getApiWhenReady().then((api) => api.goToVision6SignUp());
  };

  private onSmsBundleRemoved = ({ source }: { source: TEventSource }) => {
    if (source !== 'user') {
      return;
    }

    this.addOnsManager?.getApiWhenReady().then((api) => api.removeAddOn(ADD_ON_IDS.SMS));
  };
}
